import React, { useState, useEffect } from 'react';
import { countryService } from '../../services/api';
import './AdminPage.css';

function AdminCountry() {
  const [countries, setCountries] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCountry, setEditingCountry] = useState(null);
  const [formData, setFormData] = useState({ Name: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const data = await countryService.getCountries();
      setCountries(data);
    } catch (error) {
      alert('Error loading countries: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingCountry(null);
    setFormData({ Name: '' });
    setIsModalOpen(true);
  };

  const handleEdit = (country) => {
    setEditingCountry(country);
    setFormData({ Id: country.Id, Name: country.Name || '' });
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this country?')) {
      try {
        await countryService.deleteCountry(id);
        loadData();
      } catch (error) {
        alert('Error deleting country: ' + error.message);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await countryService.saveCountry(formData);
      setIsModalOpen(false);
      loadData();
    } catch (error) {
      alert('Error saving country: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="page-header page-headeradmin">
        <h1>Country Management</h1>
        <button className="btn-primary" onClick={handleAdd}>Add Country</button>
      </div>

      {loading && !countries.length ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {countries.map((country) => (
                <tr key={country.Id}>
                  <td>{country.Name}</td>
                  <td>
                    <button className="btn-edit" onClick={() => handleEdit(country)}>Edit</button>
                    <button className="btn-delete" onClick={() => handleDelete(country.Id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingCountry ? 'Edit Country' : 'Add Country'}</h2>
              <button className="modal-close" onClick={() => setIsModalOpen(false)}>×</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group full-width">
                  <label>Name *</label>
                  <input
                    type="text"
                    value={formData.Name}
                    onChange={(e) => setFormData({ ...formData, Name: e.target.value })}
                    required
                  />
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setIsModalOpen(false)}>Cancel</button>
                <button type="submit" className="btn-primary" disabled={loading}>
                  {loading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminCountry;

